export default __webpack_public_path__ + "static/media/guarantee.536dcb75.png";